module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workbench-w-canvas-slot', {
    attrs: {
      "loading": _vm.loading,
      "metrics": _vm.toolbarMetrics,
      "target-name": _vm.targetName,
      "activated": _vm.activated,
      "header-menu": _vm.dynamicHeaderMenu
    }
  }, [_c('workbench-row', {
    ref: "topRow",
    style: ({
      height: _vm.topRow
    })
  }, [_c('audience-size', {
    staticClass: "workbench__audience workbench__canvas-block",
    attrs: {
      "size": _vm.audienceSize
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "workbench__canvas-block workbench__additional-attributes"
  }, [_c('tabs', {
    staticClass: "workbench__stretch-canvas-block"
  }, [_c('tab', {
    attrs: {
      "name": "Additional TSP Attributes"
    }
  }, [_c('top-common-attributes', {
    attrs: {
      "attributes": _vm.topTsp
    }
  }), _vm._v(" "), (!_vm.topTsp) ? _c('api-error-message', {
    attrs: {
      "apiName": "top tsp attributes data"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('workbench-row', {
    staticClass: "workbench__property-engagement-row",
    style: ({
      height: _vm.bottomRow
    })
  }, [(!_vm.reach) ? _c('api-error-message', {
    attrs: {
      "apiName": "reach and engagement data"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('confirm-modal', {
    ref: "confirmModal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-457b30bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/workbench/SM/Sm.vue
// module id = 1875
// module chunks = 0